import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function BwtsTable({ data, onEdit }) {
  const columns = [
    {
      title: "BWTS Type",
      dataIndex: "machinery_type",
      key: "machinery_type",
      align: "center",
    },
    {
      title: "BWTS Name",
      dataIndex: "BWT_name",
      key: "BWT_name",
      align: "center",
    },
    {
      title: "BWTS Maker",
      dataIndex: "BWT_maker",
      key: "BWT_maker",
      align: "center",
    },
    {
      title: "BWTS Model",
      dataIndex: "BWT_model",
      key: "BWT_model",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
